// Shared labels for customer cancellation requests.
export const CANCELLATION_REASONS = {
    customs_fees: 'Frais de douane, taxes ou livraison imprévus',
    order_error: 'Erreur en passant la commande',
    delivery_delay: 'Délai de livraison trop long',
    changed_mind: "Changement d'avis",
    duplicate: 'Commande passée en double',
    payment: 'Problème de paiement',
    other: 'Autre motif',
}
